bovoApp.controller('CompensateListController', ['$scope', '$filter', '$timeout', 'Order',
    function ($scope, $filter, $timeout, Order) {

        $scope.filterData = {
            page: 1,
            main_customers: [],
            customers: []
        };

        $scope.data = {
            compensates: { data: [], total: 0 },
            customers: []
        };

        // Liste yüklenirken "veri yok" mesajı yerine loading göstergesi için
        $scope.loading = false;

        $scope.filterCustomers = [];

        // Müşterileri getir (data.customers'dan)
        $scope.getCustomers = function() {
            // İlk yüklemede customers data'dan gelir
            if ($scope.data.customers && $scope.data.customers.length > 0) {
                $scope.filterCustomers = $scope.data.customers;
                setTimeout(function() { $('.selectpicker').selectpicker('refresh'); }, 100);
            }
        };

        // Checkbox seçim
        $scope.selectedCompensates = [];

        $scope.toggleSelect = function(item) {
            var idx = $scope.selectedCompensates.indexOf(item.id);
            if (idx > -1) {
                $scope.selectedCompensates.splice(idx, 1);
            } else {
                $scope.selectedCompensates.push(item.id);
            }
        };

        $scope.isSelected = function(item) {
            return $scope.selectedCompensates.indexOf(item.id) > -1;
        };

        $scope.toggleSelectAll = function() {
            if ($scope.isAllSelected()) {
                $scope.selectedCompensates = [];
            } else {
                $scope.selectedCompensates = $scope.data.compensates.data.map(function(item) { return item.id; });
            }
        };

        $scope.isAllSelected = function() {
            return $scope.data.compensates.data.length > 0 &&
                $scope.selectedCompensates.length === $scope.data.compensates.data.length;
        };

        $scope.clearSelection = function() {
            $scope.selectedCompensates = [];
        };

        // Step-based workflow statuses (step field 0-6) - SOP uyumlu isimler
        $scope.compensateSteps = [
            { key: 0, name: 'Tazmin Süreci Başlatılmalı' },
            { key: 1, name: 'Fatura Girişi Yapıldı' },
            { key: 2, name: 'Yansıtılacak Birim Seçildi' },
            { key: 3, name: 'Fatura Onaylandı' },
            { key: 4, name: 'Partner Firma Onayladı' },
            { key: 5, name: 'Gönderici Firma Faturası Kesildi' },
            { key: 6, name: 'Tazmin Edildi' }
        ];

        $scope.stepText = function(item) {
            if (item.compensate_status === 'cancelled') return 'Tazmin İptal';
            if (item.compensate_status === 'rejected') return 'Tazmin Red';
            var found = $filter('filter')($scope.compensateSteps, { key: item.step }, true);
            return found && found.length > 0 ? found[0].name : '-';
        };

        $scope.stepLabel = function(item) {
            if (item.compensate_status === 'cancelled') return 'label-danger';
            if (item.compensate_status === 'rejected') return 'label-danger';
            var map = {
                0: 'label-default',
                1: 'label-info',
                2: 'label-warning',
                3: 'label-primary',
                4: 'label-warning',
                5: 'label-success',
                6: 'label-success'
            };
            return map[item.step] || 'label-default';
        };

        $scope.compensateSubjectText = function(subject) {
            var map = { 'kayip': 'Kayıp', 'kayip_okutma': 'Kayıp Kargo Okutma', 'hasar': 'Hasar', 'icerik_eksilme': 'İçerik Eksilme' };
            return map[subject] || (subject || '-');
        };

        $scope.isOverdue = function(item) {
            if (!item.invoice_deadline || item.step !== 2) return false;
            return moment(item.invoice_deadline).isBefore(moment());
        };

        $scope.daysOverdue = function(item) {
            if (!item.invoice_deadline) return 0;
            var deadline = moment(item.invoice_deadline);
            var today = moment();
            return Math.abs(today.diff(deadline, 'days'));
        };

        $scope.loadCompensates = function () {
            $scope.loading = true;
            Order.compensateOrders($scope.filterData).success(function (data) {
                $scope.data = data;
                $scope.selectedCompensates = [];
                // Customers'ı ilk yüklemede set et
                if (data.customers && data.customers.length > 0 && $scope.filterCustomers.length === 0) {
                    $scope.filterCustomers = data.customers;
                }
                $scope.loading = false;
            }).error(function () {
                $scope.loading = false;
            });
        };

        // Filtre değişikliklerini otomatik uygula (manuel "Yenile" butonu kaldırıldı).
        // Text/tarih/selectpicker değişimlerinde gereksiz istek atmamak için debounce uygulanır.
        var filterDebounce = null;
        $scope.$watch(function () {
            var f = angular.copy($scope.filterData);
            // Sayfa değişimi ayrı ele alınır (getCompensatePage), filtre watch'ını tetiklemesin
            delete f.page;
            return angular.toJson(f);
        }, function (newVal, oldVal) {
            if (newVal === oldVal) {
                return; // ilk digest — ng-init zaten yüklüyor
            }
            if (filterDebounce) {
                $timeout.cancel(filterDebounce);
            }
            filterDebounce = $timeout(function () {
                // Filtre değişince her zaman ilk sayfadan başla
                $scope.filterData.page = 1;
                $scope.loadCompensates();
            }, 400);
        });

        $scope.getCompensatePage = function (page) {
            $scope.filterData.page = page;
            $scope.loadCompensates();
        };

        $scope.clearCompensateFilter = function () {
            // filterData değişimi otomatik watch ile yeniden yüklemeyi tetikler
            $scope.filterData = { page: 1, main_customers: [], customers: [], carrier_invoiced: null, customer_invoiced: null };
            setTimeout(function() { $('.selectpicker').selectpicker('deselectAll'); }, 100);
        };

        $scope.openCompensateDetail = function (item) {
            if (item.order) {
                $scope.getOrderDetails(item.order);
            }
        };

        $scope.downloadCompensateExcel = function () {
            var params = angular.copy($scope.filterData);
            params.export = true;
            Order.compensateOrders(params).success(function (data) {
                if (data.url) {
                    window.open(data.url, '_blank');
                }
            });
        };

        $scope.downloadSelectedExcel = function () {
            var params = {
                export: true,
                selected_ids: $scope.selectedCompensates
            };
            Order.compensateOrders(params).success(function (data) {
                if (data.url) {
                    window.open(data.url, '_blank');
                }
            });
        };

        // Seçili tazminler için CRM talebi aç (ilgili taşıyıcısına tazmin talebi).
        // Timeout'u önlemek için TEK TEK (sıralı) açılır; kullanıcıya 1/30 ilerlemesi gösterilir.
        $scope.openingCrmTickets = false;
        $scope.crmProgress = null; // { current, total, created, skipped, failed }

        $scope.openSelectedCrmTickets = function () {
            if ($scope.selectedCompensates.length === 0) {
                Messenger().post({ message: 'Önce tazmin seçin.', type: 'error' });
                return;
            }

            var ids = angular.copy($scope.selectedCompensates);
            if (!confirm(ids.length + ' tazmin için CRM\'de tek tek tazmin talebi açılacak. Onaylıyor musunuz?')) {
                return;
            }

            $scope.openingCrmTickets = true;
            $scope.crmProgress = { current: 0, total: ids.length, created: 0, skipped: 0, failed: 0 };

            var index = 0;

            function finish() {
                $scope.openingCrmTickets = false;
                var p = $scope.crmProgress;
                Messenger().post({
                    message: p.total + ' tazmin işlendi. Açılan: ' + p.created + ', Atlanan: ' + p.skipped + ', Hata: ' + p.failed,
                    type: p.failed > 0 ? 'info' : 'success'
                });
                $scope.crmProgress = null;
                $scope.loadCompensates();
            }

            function processNext() {
                if (index >= ids.length) {
                    finish();
                    return;
                }

                $scope.crmProgress.current = index + 1;

                // Her istekte tek tazmin — tek CRM çağrısı, timeout riski yok
                Order.openCompensateCrmTickets({ selected_ids: [ids[index]] }).success(function (data) {
                    $scope.crmProgress.created += (data.created || 0);
                    $scope.crmProgress.skipped += (data.skipped || 0);
                    $scope.crmProgress.failed  += (data.failed || 0);
                    index++;
                    processNext();
                }).error(function () {
                    $scope.crmProgress.failed += 1;
                    index++;
                    processNext();
                });
            }

            processNext();
        };

        // Excel import
        $scope.importExcelType = '';
        $scope.importLoading = false;

        $scope.importCompensateExcel = function () {
            var fileInput = document.getElementById('compensateImportFile');
            if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
                Messenger().post({ message: 'Dosya seçmelisiniz', type: 'error' });
                return;
            }
            if (!$scope.importExcelType) {
                Messenger().post({ message: 'İşlem türü seçmelisiniz', type: 'error' });
                return;
            }

            var fd = new FormData();
            fd.append('file', fileInput.files[0]);
            fd.append('excelType', $scope.importExcelType);

            $scope.importLoading = true;
            Order.importCompensate(fd).success(function (data) {
                $scope.importLoading = false;
                $('#compensateImportModal').modal('hide');
                Messenger().post({ message: data.message, type: 'success' });
                $scope.loadCompensates();
            }).error(function (data) {
                $scope.importLoading = false;
                Messenger().post({ message: data.message || 'Yükleme hatası', type: 'error' });
            });
        };
    }
]);
